const i18n = {
    account: "Account Settings",
    activity: "Activity",
    guest: "Guest",
    download: "Download",
    marketplaceAuthorizations: "Marketplace Authorizations",
    myAssets: "My Assets",
    myLists: "My Lists",
    profile: "Profile",
    signIn: "Sign In",
    signOut: "Log Out",
    viewProfile: "View Profile",
    getCredits: "Earn Credits",
    creditsExpiringSoon: "Expiring soon",
    creditsValue: "(1 Credit = 1 MANA in value)",
    creditsExpiringIn: (value) => `Expiring in ${value} days`,
};
export { i18n };
//# sourceMappingURL=UserMenu.i18n.js.map